import { Grid } from '@mui/material';
import * as S from './styled';

export const PageLayout = ({ children }) => {
  return <S.StyledContainer>{children}</S.StyledContainer>;
};
